import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
function slider() {

    /**** Einsatzgebiete Slider (area-slider)****/
    document.querySelectorAll('.area-slider').forEach(carousel => new Swiper(carousel, {
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        spaceBetween: 30,
        loop: false,
        grabCursor: true,
        pagination: {
            el: ".swiper-pagination",
            type: "fraction",
        },
        navigation: {
            nextEl: ".swiper-button-next-area",
            prevEl: ".swiper-button-prev-area",
        },
        breakpoints: {
            600: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 3,
            }
        }
    }));


    /**** Einsatzgebiete Slider (area-slider)****/
    document.querySelectorAll('.products-zubehoer-slider').forEach(carousel => new Swiper(carousel, {
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        spaceBetween: 15,
        loop: true,
        grabCursor: true,
        pagination: {
            el: ".products-zubehoer-slider-swiper-pagination",
            type: "fraction",
        },
        navigation: {
            nextEl: ".swiper-button-next-products-zubehoer-slider",
            prevEl: ".swiper-button-prev-products-zubehoer-slider",
        },
        breakpoints: {
            600: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 2,
            }
        }
    }));


    /**** Bundle Slider ****/
    document.querySelectorAll('.products-bundle-slider').forEach(carousel => {
        const block = carousel.closest('.block-bundle');
        if (!block) return;
        new Swiper(carousel, {
            modules: [Navigation, Pagination],
            slidesPerView: 1,
            spaceBetween: 15,
            loop: false,
            grabCursor: true,
            pagination: {
                el: block.querySelector(".products-bundle-slider-swiper-pagination"),
                type: "fraction",
            },
            navigation: {
                nextEl: Array.from(block.querySelectorAll(".swiper-button-next-products-bundle-slider")),
                prevEl: Array.from(block.querySelectorAll(".swiper-button-prev-products-bundle-slider")),
            },
            breakpoints: {
                600: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 2,
                }
            }
        });
    });

}


export { slider }